<template>
    <b-card>
        <b-card-header>
            Adressregister
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col>
                    <b-row>
                        <b-col>
                            <b-input ref="inputctrl" placeholder="Sök..." v-model="flt" @input="getPlaces(flt)"
                                autofocus></b-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-select v-model="selected" :select-size="15">
                                <b-form-select-option-group label="Favoriter" v-if="favPlaces && favPlaces.length>0">
                                    <b-form-select-option v-for="x in favPlaces" :key="x.Id" :value="x.Id">{{ x.Name}},{{ x.PostCode}} {{ x.City}}</b-form-select-option>
                                </b-form-select-option-group>
                                <b-form-select-option-group label="Alla" v-if="places && places.length>0">
                                    <b-form-select-option v-for="x in places" :key="x.value" :value="x.value">{{ x.text
                                        }}</b-form-select-option>
                                </b-form-select-option-group>
                                <!-- :options="places" -->
                            </b-form-select>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col>
                    <b-row>
                        <b-col>
                            <b-button class="btn-sm" variant="outline-secondary" v-if="!isChanged()"
                                @click="newPlace()">+ Ny</b-button>
                            <b-button class="btn-sm" v-if="isChanged() && selected" @click="save()">
                                <i class="fa-regular fa-floppy-disk"></i> Spara ändringar</b-button>
                            <b-button class="btn-sm" v-if="isChanged() && !selected" @click="save()">+ Spara i
                                register</b-button>
                            <b-button class="btn-sm" variant="outline-secondary" title="Lägg till bland favoriter"
                                v-if="currPlace && !IsFav(currPlace.Id)"
                                @click="ToggleFavourite(currPlace)"><b-icon-star></b-icon-star></b-button>
                            <b-button class="btn-sm" variant="outline-secondary" title="Ta bort som favorit"
                                v-if="currPlace && IsFav(currPlace.Id)"
                                @click="ToggleFavourite(currPlace)"><b-icon-star-fill></b-icon-star-fill></b-button>
                            <b-button class="btn-sm" variant="outline-secondary" title="Sätt som standard hämtadress"                                
                                v-if="currPlace&&IsFav(currPlace.Id)&&!IsHome(currPlace.Id)"
                                @click="SetHome(currPlace,true)"><b-icon-house></b-icon-house></b-button>
                            <b-button class="btn-sm" variant="outline-secondary" title="Ta bort som standard hämtadress"                                
                                v-if="currPlace&&IsFav(currPlace.Id)&&IsHome(currPlace.Id)"
                                @click="SetHome(currPlace,false)"><b-icon-house-fill></b-icon-house-fill></b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-alert variant="danger" show v-if="errMsg.length > 0">
                                <li v-for="(err, i) in errMsg" :key="i">{{ err }}</li>
                            </b-alert>
                            <placeedit v-if="currPlace" :place="currPlace"></placeedit>
                            <!-- {{ isChanged() }} -->
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-button variant="primary" v-if="currPlace&&selected" @click="SelectPlace(currPlace)">Välj
                                denna</b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import placeedit from './placeedit.vue';

import { Api } from "../../lib/api";
const api = new Api();


export default {
    name: 'placeselect',
    components: { placeedit },
    data() {
        return {
            places: [],
            favPlaces: [],
            currPlace: null,
            flt: null,
            selected: null,
            selOrig: null,
            errMsg: [],
        }
    },
    created() {
        this.getPlaces();
    },
    watch: {
        selected: function () {
            if (this.selected)
                api.get('/api/place/GetPlace?id=' + this.selected).then(res => {
                    this.currPlace = res.data;
                    this.refreshOrig();
                }
                )
        }
    },
    methods: {
        refreshOrig() {
            this.selOrig = JSON.stringify(this.currPlace);
        },
        isChanged() {
            return this.currPlace && JSON.stringify(this.currPlace) != this.selOrig;
        },
        focus() {
            this.$refs.inputctrl.$el.focus();
        },
        getPlaces(ev) {
            // console.log("getPlaces:" + ev);
            var flt = ev;
            this.favPlaces = this.GetFavourites();
            //this.places.push({ text: "Ny", id: 44 });
            if (flt && flt.length > 0) {
                flt = flt.toLowerCase();
                var p = api.params({ filter: flt });
                api.get('/api/place/GetPlaces?' + p).then((res) => {
                    this.places = res.data;
                });
                this.favPlaces = this.favPlaces.filter(x => `${x.Name}|${x.PostCode}|${x.City}|${x.Street}|${x.Street2}|`.toLowerCase().indexOf(flt) >= 0);
            }
        },
        newPlace() {
            this.currPlace = {CountryCode:'SE'};
            //this.refreshOrig();
            this.selected = 0;
        },
        save() {
            var p = { ...this.currPlace };
            p.Id = this.selected;
            this.validate(p);
            let wasHome = this.IsHome(p.Id);
            if (this.errMsg.length == 0)
                api.post('/api/place/SavePlace', p).then(res => {
                    this.getPlaces(this.flt);//Refresh list
                    this.currPlace = res.data;
                    this.selected = res.data.Id;
                    
                    if(this.IsFav(p.Id)) {                        
                        this.ToggleFavourite(p);//Remove old
                        this.ToggleFavourite(this.currPlace);//Add new
                        if(wasHome)
                            this.SetHome(this.currPlace,true);
                    }

                    //this.SelectPlace(this.currPlace);
                    this.refreshOrig();
                });
        },
        validate(p) {
            var res = [];
            if (!p.Name || p.Name.length < 3)
                res.push('Namnet måste anges (minst 3 tecken).');

            if (!p.PostCode)
                res.push('Postnummer saknas');
            else {
                p.PostCode = p.PostCode.replace(' ', '');
                if (p.PostCode.length != 5)
                    res.push('Postnummer måste vara 5 tecken');
            }
            if (!p.City)
                res.push('Ort saknas.');

            this.errMsg = res;
        },
        SelectPlace(p) {
            this.$emit('placeselected', p);
        },
        GetFavourites() {
            var res = [];
            var f = localStorage.getItem('favplaces');
            if (f)
                res = JSON.parse(f);

            return res;
        },
        IsHome(id) {
            var p = this.FindFav(id);
            return (p && p.isHome);
        },
        IsFav(id) {
            return this.FindFav(id) != null;
        },
        FindFav(id) {
            var favs = this.GetFavourites();
            return favs.find(x => x.Id == id);
        },
        GetHomeAddress() {
            var favs = this.GetFavourites();
            var h = favs.find(x => x.isHome);
            return h;
        },
        ToggleFavourite(p) {
            var currFavs = this.GetFavourites();
            var f = this.FindFav(p.Id);
            if (f)
                currFavs = currFavs.filter(x => x.Id != p.Id)
            else
                currFavs.push(p);            
            localStorage.setItem('favplaces', JSON.stringify(currFavs));
            this.getPlaces();
        },
        SetHome(p,v) {
            var favs = this.GetFavourites();
            favs.forEach(x => x.isHome = (x.Id == p.Id) ? v : null);                
            localStorage.setItem('favplaces', JSON.stringify(favs));  
            this.getPlaces();         
        }
    }
}
</script>